<template>
  <o-loading :full-page="true" :active="isLoading" :can-cancel="false"></o-loading>
  <div class="has-background-white qr-labels">
    <div class="column">
      <div class="columns is-centered">
        <div class="column is-9 my-4 has-background-grey-lighter">
          <div class="column has-text-black-bis is-size-4 has-text-weight-bold">
            <div class="columns is-align-items-center">
              <div class="column"><h2 class="is-size-2 has-text-weight-bold has-black-bis">Company QR Labels</h2></div>
              <div class="column is-flex is-justify-content-end is-align-items-center">
               
                <div v-if="!edit && hasPermission" class="is-flex">
                  <button class="button has-text-black-bis p-0 mr-2" @click="isActivityActive = true">
                  <i class="icon-activityhistory"></i>
                  </button>
                  <div class="is-divider-vertical"></div>
                  <button class="button has-text-black-bis p-0" @click="edit = !edit">
                    <i class="icon-edit"></i>
                  </button>
                </div>
                <div v-if="edit">
                  <button class="button is-outlined mr-2  p-0" @click="cancelEdit">
                    <i class="icon-close"></i>
                  </button>
                  <button class="button is-success p-0" @click="saveCompany()">
                    <i class="icon-checkmark"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="is-divider my-3"></div>
            <div class="columns">
              <div class="column"  v-if="edit">
                <h3 class="has-text-weight-semibold is-size-3">QR Code Company Logo</h3>
                <div class="is-divider my-3"></div>
                <div class="column is-6 is-flex is-justify-content-start is-align-items-center">
                  <div class="upload-log is-pulled-left is-size-6 has-text-weight-semibold line-height mr-3
                  is-flex is-align-items-center is-justify-content-center">
                    140 x 40 32-bit PNG
                  </div>
                  <div v-if="customTemplate.companyLogo">
                    <button class="button has-background-black-bis has-text-white" @click="removeLogo">
                      Remove Current Logo
                    </button>
                  </div>
                  <div v-else>
                    <mf-file v-model="customTemplate.companyLogo" path="companies/addQrCompanyLogo" filePath="imageUrl"
                      accept="image/png" :param="{ company: company._id, type: 'companies' }"
                      errorMsg="Image size must be 140 px wide, 40 px height, PNG 32 Bit format" :multiple="false"
                      :isImageUpload="true" @onInput="getLogo">
                      Add Image
                    </mf-file>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <h3 class="is-size-3 has-text-weight-semibold has-text-black-bis">Production Manager</h3>
            <div class="is-divider my-3"></div>
            <div class="columns">
              <qr-sample :edit="edit" :logo="imageUrl" @setDefault="setDefault" :companyName="company.name"
                @removeLogo="removeLogo" type="shipping" :options="get(labelOptions, 'shipping.options', [])"
                :labels="customTemplate.shipping" @update:labels="val => customTemplate.shipping = val" title="" />
              <qr-sample :edit="edit" :logo="imageUrl" :companyName="company.name" @setDefault="setDefault" type="item"
                :options="get(labelOptions, 'item.options', [])" :labels="customTemplate.item"
                @update:labels="val => customTemplate.item = val" title="" />
            </div>
            <h3 class="is-size-3 has-text-weight-semibold has-text-black-bis">Material Manager</h3>
            <div class="is-divider my-3"></div>
            <div class="columns">
              <qr-sample :edit="edit" :logo="imageUrl" @setDefault="setDefault" :companyName="company.name"
                type="material" :options="get(labelOptions, 'material.options', [])" :labels="customTemplate.material"
                @update:labels="val => customTemplate.material = val" title="" />
              <qr-sample :edit="edit" :logo="imageUrl" :companyName="company.name" @setDefault="setDefault"
                type="materialItems" :options="get(labelOptions, 'materialItems.options', [])"
                :labels="customTemplate.materialItems" @update:labels="val => customTemplate.materialItems = val"
                title="" />
            </div>
            <h3 class="is-size-3 has-text-weight-semibold has-text-black-bis">Shipping</h3>
            <div class="is-divider my-3"></div>
            <div class="columns">
              <div class="column  px-0">
                <qr-sample :edit="edit" :logo="imageUrl" :companyName="company.name" @setDefault="setDefault"
                  type="partial" :options="get(labelOptions, 'partial.options', [])" :labels="customTemplate.partial"
                  @update:labels="val => customTemplate.partial = val" title="" />
              </div>
              <div class="column px-0">
                <qr-sample :edit="edit" :logo="imageUrl" :companyName="company.name" @setDefault="setDefault"
                  type="serial" :options="get(labelOptions, 'serial.options', [])" :labels="customTemplate.serial"
                  @update:labels="val => customTemplate.serial = val" title="" />
              </div>
            </div>
            <h3 class="is-size-3 has-text-weight-semibold has-text-black-bis">Inventory</h3>
            <div class="is-divider my-3"></div>
            <div class="columns">
              <div class="column is-6 px-0">
                <qr-sample :edit="edit" :logo="imageUrl" @setDefault="setDefault" :companyName="company.name"
                  type="inventoryItem" :options="get(labelOptions, 'inventoryItem.options', [])"
                  :labels="customTemplate.inventoryItem" @update:labels="val => customTemplate.inventoryItem = val"
                  title="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <activity-slider
      :isActive="isActivityActive"
      :id="companyId"
      module="Company"
      :company="companyId"
      @update:isActive="isActivityActive = false"
    />
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted, toRefs } from 'vue';
import { useStore } from 'vuex';
import { isEmpty, isObject, map, some, size, cloneDeep, forEach, get } from 'lodash';
import MfFile from '@/components/MfFilePicker.vue';
import QrSample from '@/views/QrSample.vue';
import QrDefault from '@/views/QRLabelSettings';
import s3FileAccess from '@/models/SimpleStorageService';
import Companies from '@/models/Companies';
import ActivitySlider from '@/components/ActivitySlider.vue';
import PermissionMixin from '@/components/mixins/PermissionMixin';

export default defineComponent({
  name: 'QrLabel',
  components: {
    QrSample,
    MfFile,
    ActivitySlider
  },
  setup(props) {
    const store = useStore();
    const labelOptions = QrDefault;
    const { getPermissionValues } = PermissionMixin();

    const data = reactive({
      company: {},
      dataLoaded: false,
      edit: false,
      imageUrl: '',
      customTemplate: {},
      beforeEdit: {},
      isLoading: false,
      isActivityActive: false,
      hasPermission: true
    });

    const isOldSettings = computed(() =>
      some(labelOptions, (label, key) => {
        const currentLen = size(data.company.qrLabel?.[key]);
        const defaultLen = size(label.default);
        return currentLen !== defaultLen;
      })
    );

    const getLogo = async (file) => {
      try {
        data.customTemplate.companyLogo = file || data.customTemplate.companyLogo;
        const fileGuid = get(data.customTemplate, 'companyLogo.fileGuid', '');
        if (data.company._id && fileGuid !== '') {
          const { presignedUrl } = await s3FileAccess.getS3File({
            type: 'company',
            id: fileGuid,
          });
          data.imageUrl = presignedUrl;
          return true;
        }
        data.imageUrl = '';
        return false;
      } catch (error) {
        console.error('Error fetching logo:', error);
      }
    }

    const setDefault = (type) => {
      data.customTemplate[type] = cloneDeep(labelOptions[type].default);
    }

    const removeLogo = () => {
      data.customTemplate.companyLogo = '';
    }

    const companyId = computed(() => store.state.userData?.company || '');
    const saveCompany = async () => {
      try {
        await Companies.saveQrLabel({ qrlabel: data.customTemplate, company: data.company._id });
        data.company = await Companies.getOne(store.state.userData.company);
        data.customTemplate = cloneDeep(data.company.qrLabel || {});
        data.beforeEdit = cloneDeep(data.customTemplate);
        await getLogo();
      } catch (error) {
        console.error('Error saving company QR label settings:', error);
      } finally {
        data.edit = false;
      }
    }

    const cancelEdit = async () => {
      data.customTemplate = cloneDeep(data.beforeEdit);
      await getLogo(get(data.customTemplate, 'companyLogo', ''));
      data.edit = false;
    }

    onMounted(async () => {
      try {
        data.isLoading= true;
        data.hasPermission = !(getPermissionValues({
          permissionModule: 'app&projects',
          type: 'companyQr',
        }))
        data.company = await Companies.getOne(store.state.userData.company);
        if (isEmpty(data.company.qrLabel) || isOldSettings.value) {
          if (!isObject(data.company.qrLabel)) data.company.qrLabel = {};
          map(labelOptions, (label, key) => {
            data.company.qrLabel[key] = cloneDeep(label.default);
          });
          Object.assign(data.customTemplate, cloneDeep(data.company.qrLabel));
        } else {
          Object.assign(data.customTemplate, cloneDeep(data.company.qrLabel));
        }
        data.beforeEdit = cloneDeep(data.customTemplate);
        await getLogo();
      } catch (error) {
        console.error('Error loading company data:', error);
      } finally {
        data.dataLoaded = true;
        data.isLoading = false;
      }
    });

    return {
      ...toRefs(data),
      labelOptions,
      getLogo,
      setDefault,
      removeLogo,
      saveCompany,
      cancelEdit,
      get,
      companyId,
    };
  },
});
</script>

<style></style>
